<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="需求统计"
      :page="false"
      max-height="650px"
      :show-summary="true"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getStat"
    >
      <template slot="toolbar-right">
        <span style="font-size: 14px;vertical-align: text-top;color: #606266;">文件名称：</span>
        <el-input style="width:220px;" size="mini" v-model="fileName" />
        <el-button style="margin-left:10px;" size="mini" type="primary" @click="exportExl">导 出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="统计类型">
          <el-select size="mini" v-model="params.type">
            <el-option label="按申请科室展示" :value="0"></el-option>
            <el-option label="按时间段展示" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            size="mini"
            v-model.trim="params.startDate"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.endDate"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Name" :label="params.type==0?'科室名称':'月份'" />
        <el-table-column prop="Count" label="申请数量" />
        <el-table-column prop="PassCount" label="审核通过数量" />
        <el-table-column prop="DevelopCount" label="开发中数量" />
        <el-table-column prop="TestCount" label="测试中数量" />
        <el-table-column prop="CompleteCount" label="已完成数量" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    exportDialog,
  },
  data() {
    var today = this.$commonJs.toDateStringByFormat(new Date(), "YYYYMMDD");
    return {
      api: require("@/api/bm/requirement").default,
      params: {
        type: 0,
        startDate: null,
        endDate: null,
      },
      fileName: "需求统计" + today,
    };
  },
  methods: {
    exportExl() {
      if (!this.fileName) {
        this.$message.warning("请先填写文件名");
        return;
      }
      this.$refs.exportDialog
        .open({ fileName: this.fileName, type: this.params.type })
        .then((that) => {
          that.getData(this.params);
        });
    },
  },
};
</script>